/*
 * Pure helpers around the `?auth=` query that drives the auth popup.
 * No router/store imports — src/router/index.js depends on this, so it must stay
 * a leaf module.
 */
export const AUTH_QUERY_KEY = 'auth'

export const AUTH_VIEW = {
  LOGIN: 'login',
  REGISTER: 'register',
  FORGOT_PASSWORD: 'forgot-password'
}

const AUTH_VIEWS = [AUTH_VIEW.LOGIN, AUTH_VIEW.REGISTER, AUTH_VIEW.FORGOT_PASSWORD]

export function isAuthView(view) {
  return AUTH_VIEWS.indexOf(view) !== -1
}

export function getAuthViewFromRoute(route) {
  const query = (route && route.query) || {}
  const view = query[AUTH_QUERY_KEY]
  return isAuthView(view) ? view : ''
}

/* `to` and `from` differ only by the auth query — a popup toggle, not a page change */
export function isAuthQueryOnlyNavigation(to, from) {
  if (!to || !from) return false
  if (to.path !== from.path) return false

  const toQuery = Object.assign({}, to.query)
  const fromQuery = Object.assign({}, from.query)
  delete toQuery[AUTH_QUERY_KEY]
  delete fromQuery[AUTH_QUERY_KEY]

  const toKeys = Object.keys(toQuery)
  if (toKeys.length !== Object.keys(fromQuery).length) return false

  return toKeys.every(function (key) {
    return String(toQuery[key]) === String(fromQuery[key])
  })
}



// WEBPACK FOOTER //
// ./src/utils/authQuery.js